module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-karite.a4565626.jpg";